
<app-breadcrumb
  [title]="'Lista de Cumpleaños'"
  [items]="['Personas']"
  [active_item]="'Cumpleaños'">
</app-breadcrumb>

<div class="container-fluid cumpleanos-page">

  <!-- ENCABEZADO -->
  <div class="page-heading">
    <div>
      <h4><i class="icofont icofont-birthday-cake"></i> Cumpleaños del personal</h4>
      <p>Consulta y seguimiento de cumpleaños de los empleados.</p>
    </div>
  </div>

  <!-- INDICADORES -->
  <div class="row g-3 mb-4">
    <div class="col-12 col-sm-6 col-xl-3">
      <div class="stat-card stat-today">
        <div class="stat-icon"><i class="fa fa-birthday-cake"></i></div>
        <div>
          <span>Cumpleaños hoy</span>
          <h3>{{ resumen.hoy }}</h3>
          <small>Empleados por felicitar</small>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="stat-card stat-tomorrow">
        <div class="stat-icon"><i class="fa fa-calendar-check-o"></i></div>
        <div>
          <span>Cumpleaños mañana</span>
          <h3>{{ resumen.manana }}</h3>
          <small>Próximas celebraciones</small>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="stat-card stat-month">
        <div class="stat-icon"><i class="fa fa-calendar"></i></div>
        <div>
          <span>Este mes</span>
          <h3>{{ resumen.mes }}</h3>
          <small>Cumpleaños del mes actual</small>
        </div>
      </div>
    </div>

    <div class="col-12 col-sm-6 col-xl-3">
      <div class="stat-card stat-total">
        <div class="stat-icon"><i class="fa fa-users"></i></div>
        <div>
          <span>Total de empleados</span>
          <h3>{{ filteredTableItems.length }}</h3>
          <small>Registros cargados</small>
        </div>
      </div>
    </div>
  </div>

  <!-- LISTADO -->
  <div class="card birthday-card">
    <div class="card-header birthday-header">
      <div>
        <h5><i class="fa fa-list-ul me-2"></i>Listado de cumpleaños</h5>
        <small>Ordenados por la próxima fecha de cumpleaños</small>
      </div>
      <span class="total-badge">{{ filteredTableItems.length }} registros</span>
    </div>

    <div class="card-body">

      <!-- FILTROS -->
      <div class="row g-3 align-items-end mb-4">
        <div class="col-12 col-md-6 col-xl-5">
          <label for="buscarCumpleanos" class="form-label">Buscar empleado</label>
          <div class="input-group">
            <span class="input-group-text"><i class="fa fa-search"></i></span>
            <input
              id="buscarCumpleanos"
              type="search"
              class="form-control"
              placeholder="Cédula, nombre o apellido..."
              [(ngModel)]="searchText"
              (ngModelChange)="filterData()">
            <button
              *ngIf="searchText"
              type="button"
              class="btn btn-outline-secondary"
              aria-label="Limpiar búsqueda"
              (click)="searchText = ''; filterData()">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>

        <div class="col-12 col-md-4 col-xl-3">
          <label for="filtroMes" class="form-label">Mes de nacimiento</label>
          <select
            id="filtroMes"
            class="form-select"
            [(ngModel)]="mesSeleccionado"
            (ngModelChange)="filterData()">
            <option [ngValue]="0">Todos los meses</option>
            <option *ngFor="let mes of meses" [ngValue]="mes.valor">
              {{ mes.nombre }}
            </option>
          </select>
        </div>

        <div class="col-12 col-md-2 col-xl-2">
          <label for="filtroEstado" class="form-label">Estado</label>
          <select
            id="filtroEstado"
            class="form-select"
            [(ngModel)]="estadoSeleccionado"
            (ngModelChange)="filterData()">
            <option value="TODOS">Todos</option>
            <option value="HOY">Hoy</option>
            <option value="MANANA">Mañana</option>
            <option value="PROXIMO">Próximos 7 días</option>
          </select>
        </div>

        <div class="col-12 col-xl-2">
          <button
            type="button"
            class="btn btn-outline-secondary w-100"
            >
            <i class="fa fa-eraser me-1"></i> Limpiar filtros
          </button>
        </div>
      </div>

      <!-- CARGA -->
      <div *ngIf="loading" class="loading-state">
        <div class="spinner-border text-danger" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <span>Cargando cumpleaños...</span>
      </div>

      <!-- TABLA -->
      <div *ngIf="!loading" class="table-responsive">
        <table class="table table-hover align-middle birthday-table">
          <thead>
            <tr>
              <th scope="col">
                <button class="sort-button" (click)="sortData('cedula')">
                  CÉDULA <i class="fa" [ngClass]="iconoOrden('cedula')"></i>
                </button>
              </th>

              <th scope="col">
                <button class="sort-button" (click)="sortData('primernombre')">
                  EMPLEADO <i class="fa" [ngClass]="iconoOrden('primernombre')"></i>
                </button>
              </th>

              <th scope="col">
                <button class="sort-button" (click)="sortData('fechanace')">
                  FECHA DE NACIMIENTO
                  <i class="fa" [ngClass]="iconoOrden('fechanace')"></i>
                </button>
              </th>

              <th scope="col">DÍA Y MES</th>

              <th scope="col">
                <button class="sort-button" (click)="sortData('edad')">
                  EDAD <i class="fa" [ngClass]="iconoOrden('edad')"></i>
                </button>
              </th>

              <th scope="col">PRÓXIMO CUMPLEAÑOS</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="
              let propietario of filteredTableItems
                | paginate: { itemsPerPage: pageSize, currentPage: page };
              trackBy: trackByCedula">

              <td class="text-center">{{ propietario.cedula }}</td>

              <td>
                <div class="employee-name">
                  <span class="employee-avatar">
                    {{ iniciales(propietario) }}
                  </span>
                  <span>
                    {{ nombreCompleto(propietario) }}
                  </span>
                </div>
              </td>

              <td class="text-center">
                {{ propietario.fechanace | date:'dd/MM/yyyy' }}
              </td>

              <td class="text-center">
                {{ propietario.diaNacimiento }} de {{ propietario.mesNacimiento }}
              </td>

              <td class="text-center">{{ propietario.edad ?? '—' }}</td>

              <td class="text-center">
                <span
                  class="birthday-status"
                  [ngClass]="'status-' + estadoCumpleanos(propietario).toLowerCase()">
                  <i
                    class="fa"
                    [ngClass]="{
                      'fa-birthday-cake': estadoCumpleanos(propietario) === 'HOY',
                      'fa-calendar-check-o': estadoCumpleanos(propietario) === 'MANANA',
                      'fa-calendar': estadoCumpleanos(propietario) === 'PROXIMO',
                      'fa-calendar-o': estadoCumpleanos(propietario) === 'PROGRAMADO'
                    }">
                  </i>
                  {{ etiquetaEstado(propietario) }}
                </span>
              </td>
            </tr>

            <tr *ngIf="filteredTableItems.length === 0">
              <td colspan="6" class="empty-state">
                <i class="fa fa-calendar-times-o"></i>
                <h6>No se encontraron cumpleaños</h6>
                <p>Prueba con otro nombre, cédula, mes o estado.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PAGINACIÓN -->
      <div *ngIf="!loading && filteredTableItems.length > 0"
           class="pagination-footer">
        <div class="page-size-control">
          <label for="pageSize">Mostrar:</label>
          <select
            id="pageSize"
            class="form-select form-select-sm"
            [(ngModel)]="pageSize"
            (ngModelChange)="page = 1">
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
          <span>por página</span>
        </div>

        <div class="pagination-total">
          {{ filteredTableItems.length }} resultado(s)
        </div>

        <pagination-controls
          (pageChange)="page = $event"
          [maxSize]="5"
          [directionLinks]="true"
          [autoHide]="true"
          previousLabel="Anterior"
          nextLabel="Siguiente">
        </pagination-controls>
      </div>

      <!-- EXPORTACIONES -->
      <div class="export-actions">
        <button
          type="button"
          class="btn btn-outline-success"
          [disabled]="filteredTableItems.length === 0"
          (click)="exportarExcel()">
          <i class="icofont icofont-file-excel me-1"></i> Exportar Excel
        </button>

        <button
          type="button"
          class="btn btn-outline-danger"
          [disabled]="filteredTableItems.length === 0"
          (click)="exportarPDF()">
          <i class="icofont icofont-file-pdf me-1"></i> Exportar PDF
        </button>
      </div>

    </div>
  </div>

  <!-- GRÁFICO EXISTENTE -->
  <div class="card birthday-card mt-4">
    <div class="card-header birthday-header">
      <h5><i class="fa fa-bar-chart me-2"></i>Cumpleaños por mes</h5>
    </div>
    <div class="card-body chart-container">
      <app-graficos-cumpleanos
        [labels]="chartLabels"
        [data]="chartData">
      </app-graficos-cumpleanos>
    </div>
  </div>

</div>
